import router from './router'
import store from './store'
import Vue from 'vue'
// import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, getUserTokenKey, setUserToken, getlogoutFlag, setLogoutFlag } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  if (to.query.hideBpmNav) {
    sessionStorage.setItem('hideBpmNav', true)
  }
  // start progress bar
  NProgress.start()
  // set page title
  document.title = getPageTitle(to.meta.title)
  // determine whether the user has logged in
  const hasToken = getToken()
  const hasUserToken = getUserTokenKey()
  const getlogout = getlogoutFlag()
  if (to.meta.isInFrame) {
    Vue.prototype.$isInFrame = true
  }
  if (to.meta.isInKa) {
    Vue.prototype.$isInKa = true
    Vue.prototype.$isInFrame = true
  }
  if (hasToken) {
    if (Vue.prototype.$isInFrame) {
      store.commit('app/SET_IN_FRAME', true)
    }
    if (Vue.prototype.$isInFrame && to.path === '/login') {
      next({ path: '/login', replace: true })
    } else if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles
      if (hasRoles) {
        if (to.matched.length !== 0) {
          next()
        } else {
          next({ path: '/404' })
        }
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          await store.dispatch('user/getInfo')

          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('permission/generateRoutes')
          // dynamically add accessible routes
          router.addRoutes(accessRoutes)
          // 获取全局系统变量
          store.dispatch('system/getSystem')
          if (!store.state.async.hasInfo) {
            store.dispatch('async/getOrgInfo')
          }
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          if (to.path !== from.path) {
            next({ ...to, replace: true })
          }
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          // Message.error({ message: error || 'Has Error' })
          if (to.path !== from.path) {
            next(`/login?redirect=${to.path}`)
          }
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    const href = window.location.href
    if ((hasUserToken && getlogout !== hasUserToken) || (href.indexOf('vt_param') !== -1 && to.query.redirect === '/home/index')) {
      var paramArr = []
      if (!hasUserToken || (href.indexOf('vt_param') !== -1)) {
        paramArr = href.split('=')[1].split('#')
      }
      if (hasUserToken || paramArr.length) {
        if (hasUserToken || paramArr[0]) {
          // return
          const loginForm = {
            loginName: '',
            password: '',
            ssoToken: paramArr[0] || hasUserToken
          }
          store.dispatch('user/login', loginForm)
            .then((res) => {
              setUserToken(paramArr[0] || hasUserToken)
              if (res.accessToken) {
                store.commit('user/SET_SSOTOKEN', paramArr[0] || hasUserToken)
                localStorage.setItem('is-sso-login', true)
                next('/')
              }
            }).catch(() => {
              setLogoutFlag()
              next('/login')
            })
        }
      }
      return
    }
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      if (to.matched.length !== 0) {
        next()
      } else {
        next({ path: '/404' })
      }
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})

// 按钮级判断
export const isPermission = (code) => {
  const codeList = store?.state?.permission?.buttonList?.map((item) => item.code) || []
  if (Array.isArray(code)) {
    let found = false
    for (let i = 0; i < code.length; i++) {
      if (codeList.indexOf(code[i]) > -1) {
        found = true
        break
      }
    }
    return found
  }
  return codeList.includes(code)
}
// 页面级判断
export const isPagePermission = (code) => {
  const codeList = store?.state?.permission?.menuList?.map((item) => item.code) || []
  if (Array.isArray(code)) {
    let found = false
    for (let i = 0; i < code.length; i++) {
      if (codeList.indexOf(code[i]) > -1) {
        found = true
        break
      }
    }
    return found
  }
  return codeList.includes(code)
}
